/*
 * Title: Leaderboard/FansContent.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: All Leaders position listing.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import * as React from "react";
import Buttonlink from "@components/Button";
import { motion } from "framer-motion";

const animations = {
  initial: { opacity: 0, x: 100 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -100 },
};
type Props = {};

const FansContent: React.FC<Props> = (props) => {
  return (
    <div className="relative">
      <div
        className="overflow-x-hidden overflow-y-auto tabs-height-leader"
        id="scrollbar">
        <motion.div
          variants={animations}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={{ duration: 0.5 }}
          id="scrollbar"
          className="overflow-x-hidden overflow-y-auto tabs-height-leader">
          <div className="flex flex-col items-center justify-center h-full space-y-5">
            <h4 className="text-[24px] text-white font-normal">
              Compete with friends
            </h4>
            <p className="text-[#fff]/80 text-[18px] font-normal text-center max-w-md w-full leading-6">
              To view the{" "}
              <b className="font-semibold text-[18px]">Fans I Know</b>{" "}
              leaderboard, please grant us read-only access to view the accounts
              you’re connected with on social.
            </p>
            {/* <Buttonlink
              text="approve access"
              className="flex items-center justify-center font-medium text-black text-[18px] bg-primary rounded-full w-[189px] h-[42px] mx-auto"
            /> */}
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default FansContent;
